const loadGoogleMapsAPI = require('load-google-maps-api')

export default {
  data () {
    return {
      // Milliseconds to poll for Google Maps API availability
      googleMapsApiTimeout: 10000
    }
  },
  mounted () {
    if (this.autocomplete.fields) {
      // Prevent API from being loaded multiple times (if there are multiple forms)
      if (!window.googleMapsLoaded) {
        this._loadGoogleMapsApi()
      } else {
        this._checkGoogleMapApiLoaded()
      }
      window.googleMapsLoaded = true
    }
  },
  methods: {
    /**
     * Load the Google Maps API
     */
    _loadGoogleMapsApi () {
      loadGoogleMapsAPI({
        key: this.autocomplete.apiKey,
        libraries: ['places'],
        v: 3
      }).then(function (googleMaps) {
        window.google = { maps: googleMaps }
        // Define global method that will be called if there's any kind of API
        // auth error, like quota limit or blocked host. We'll just notify Rollbar.
        window.gm_authFailure = function () {
          this._report('error', 'Google Maps API Auth Error')
        }.bind(this)
        this._initAutoComplete(googleMaps)
      }.bind(this)).catch((err) => {
        console.error(err)
      })
    },

    /**
     * Poll window until Google Maps API is loaded
     */
    _checkGoogleMapApiLoaded () {
      if (window.google && window.google.maps) {
        this.$info('Google Maps API loaded')
        this._initAutoComplete(window.google.maps)
      } else if (this.googleMapsApiTimeout > 0) {
        // Check every 250ms if API loaded, but only until timeout value is exhausted
        this.googleMapsApiTimeout -= 250
        setTimeout(this._checkGoogleMapApiLoaded, 250)
      } else {
        this.$error('Unable to detect Google Maps API')
      }
    },

    /**
     * Initialize all autocomplete fields
     *
     * @param  {Object} googleMaps The Google Maps API
     */
    _initAutoComplete (googleMaps) {
      this.autocomplete.fields.forEach(function (autocompleteFieldConfig) {
        // Get our 'main' address field vm; user may specify a config object or just a string with the main field name
        var mainFieldVm = this.field(autocompleteFieldConfig.main.fieldName || autocompleteFieldConfig.main)
        var inputEl = mainFieldVm.$refs.input

        // Bind enter-key behavior
        this._handleEnterKey(googleMaps, inputEl)

        // Init the dropdown on our 'main' address field
        var address = new window.google.maps.places.Autocomplete(inputEl, {types: ['address']})

        // Listen for address changes and autopopulate other address fields
        address.addListener('place_changed', function () {
          // Set config for how we want to display our 'main' address parts
          var mainAddressConfig = this._getMainAddressConfig(autocompleteFieldConfig)
          var mainAddressParts = []
          var place = address.getPlace()
          // Iterate through all components of the address returned by Google,
          // and grab the values as specified by the autocomplete config
          for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0]

            // If current part needs to be grabbed for the 'main' address, push it to the mainAddressParts
            if (typeof mainAddressConfig.format[addressType] !== 'undefined') {
              mainAddressParts.push(place.address_components[i][mainAddressConfig.format[addressType]])
            }

            // Now we'll populate and validate any other fields as specified in
            // the autocomplete config
            var fieldConfig = typeof autocompleteFieldConfig.otherFieldsMap !== 'undefined' ? autocompleteFieldConfig.otherFieldsMap[addressType] : undefined

            if (typeof fieldConfig !== 'undefined') {
              var value = place.address_components[i][fieldConfig.value]
              var fieldVm = this.field(autocompleteFieldConfig.otherFieldsMap[addressType].fieldName)
              if (fieldVm) {
                fieldVm.value = value
                fieldVm.validate(true)
              }
            }
          }

          // Finally populate our main address
          mainFieldVm.value = mainAddressParts.join(' ')
          mainFieldVm.validate(true)
          mainFieldVm.focus()
          // I can't find a way to programmatically close the autocomplete dropdown
          // but triggering an escape keypress does the trick
          this.$nextTick(function () {
            const event = new KeyboardEvent('keydown', { keyCode: 27, key: 'Escape' })
            mainFieldVm.$refs.input.dispatchEvent(event)
          })
        }.bind(this))
      }.bind(this))
    },

    /**
     * Bind behavior for the enter key.
     *
     * We need to prevent the normal enter key behavior (form submission) if user
     * is selecting a place from the autocomplete list
     *
     * @param  {object} googleMaps Google Maps API
     * @param  {HTMLElement} inputEl    The input field
     */
    _handleEnterKey (googleMaps, inputEl) {
      googleMaps.event.addDomListener(inputEl, 'keydown', function (e) {
        // Determine if a google places dropdown list is visible. If so, cancel
        // enter key behavior to prevent form from being submitted
        var list = document.querySelectorAll('.pac-container')
        var placesDropdownVisible = Array.prototype.some.call(list, function (item) {
          return window.getComputedStyle(item).display !== 'none'
        })
        if (e.keyCode === 13 && placesDropdownVisible) {
          e.preventDefault()
          e.stopPropagation()
        }
      })
    },

    /**
     * Get the configuration object for how we want to format the 'main' address
     * field
     *
     * @param  {object} autocompleteFieldConfig
     * @return {object}
     */
    _getMainAddressConfig (autocompleteFieldConfig) {
      // If the config specifies only a string, use the default config
      return typeof autocompleteFieldConfig.main === 'string'
          // Default format: [street_number] [route], e.g. "3335 E Baseline Rd"
          ? {
            fieldName: autocompleteFieldConfig.main,
            format: {
              // Remember, order does not matter here, the pieces will always
              // be displayed in normal order, e.g. street number before street
              // name, city before state, etc.
              street_number: 'short_name',
              route: 'short_name'
            }
          }
          // Use format as specified in config
          : autocompleteFieldConfig.main
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/form/autocomplete.js